.chart-wrapper{min-height:300px}::ng-deep .small-chart .chart-wrapper{min-height:275px}
/*# sourceMappingURL=bar-chart.component-U4SLZQTI.css.map */
